export default "__VITE_ASSET__D_Hiw5sR__"